import {Route, Routes} from 'react-router-dom';
import Navbar from './components/Navbar';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Footer from './components/Footer';
import AppleMusicRd from './caseStudies/AppleMusicRd';
import FoodTracker from './caseStudies/FoodTracker';
import AsuProj from './caseStudies/AsuProj';
import './App.css';
import Home from './pages/Home';
import JourneyMapReport from './caseStudies/JourneyMapReport';
import SonosAppRd from './caseStudies/SonosAppRd';
import AdaptableLogic from './caseStudies/AdaptableLogic';
import CaniProject from './caseStudies/CaniProject';
import HelpUsServe from './caseStudies/HelpUsServe';

function App() {
    return (
        <div className="app-container">
            <div id="top" />

            <Navbar/>

                <div className="content-wrapper">
                    <Routes>
                        <Route path="/" element={<Home/>}/>
                        <Route path="/projects" element={<Projects/>}/>
                        <Route path="/contact" element={<Contact/>}/>

                        <Route path="/projects/apple-music" element={<AppleMusicRd />} />
                        <Route path="/projects/food-tracker" element={<FoodTracker />} />
                        <Route path="/projects/type-specimen" element={<AsuProj />} />
                        <Route path="/projects/journey-map-report" element={<JourneyMapReport />} />
                        <Route path="/projects/sonos-app" element={<SonosAppRd />} />
                        <Route path="/projects/adaptablelogic" element={<AdaptableLogic />} />
                        <Route path="/projects/cani" element={<CaniProject />} />
                        <Route path="/projects/help-us-serve" element={<HelpUsServe />} />
                    </Routes>
                </div>

            <Footer/>
        </div>
    );
}

export default App;
